import { NgModule } from '@angular/core';
import { TicketMainComponent } from './ticket-main.component';
import { TicketItemComponent } from '../ticket-item/ticket-item.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BasicInputModule } from 'src/app/components/(shareds)/basic-input/basic-input.module';
import { ReservationItemModule } from '../reservation-item/reservation-item.module';
import { TicketItem3Component } from '../ticket-item3/ticket-item3.component';
import { ImportModule } from 'src/app/import.module';

import { TicketItem2Component } from '../ticket-item2/ticket-item2.component';
import { TranslatePipeModule } from 'src/app/pipes/translate.module';

@NgModule({
  imports: [
    ImportModule,
    ReactiveFormsModule,
    BasicInputModule,
    ReservationItemModule,
    TranslatePipeModule,
    // TicketItem2Module,
  ],
  declarations: [
    TicketMainComponent,
    TicketItemComponent,
    TicketItem2Component,
    TicketItem3Component,
  ],
  exports: [
    TicketMainComponent,
    TicketItem2Component,
    TicketItemComponent,
    TicketItem3Component,
  ],
})
export class TicketMainModule {}
